import React from 'react';
import CustomerTextInput from '../../../inputs/customerTextInput/CustomerTextInput';
import useTranslation from '../../../../hooks/translation/useTranslation';

function LegalCustomerBookingInfo() {
  const { trans } = useTranslation();
  return (
    <>
      <CustomerTextInput
        label={trans('organization_name')}
        name={['booker', 'organization_name']}
        disabled
        rules={[{
          required: true,
          message: trans('input_necessary'),
        }]}
      />
      <CustomerTextInput
        label={trans('identification_number')}
        name={['booker', 'id_number']}
        disabled
        rules={[{
          required: true,
          message: trans('input_necessary'),
        }]}
      />
      <CustomerTextInput
        label={trans('phone_number')}
        name={['booker', 'phone_number']}
        disabled
        rules={[{
          required: true,
          message: trans('input_necessary'),
        }]}
      />
      <CustomerTextInput
        label={trans('email')}
        name={['booker', 'email']}
        disabled
        rules={[{
          required: true,
          message: trans('input_necessary'),
        }]}
      />
      <CustomerTextInput
        label={trans('country')}
        name={['booker', 'country']}
        disabled
        rules={[{
          required: true,
          message: trans('input_necessary'),
        }]}
      />
      <CustomerTextInput
        label={trans('address')}
        name={['booker', 'address']}
        rules={[{
          required: true,
          message: trans('input_necessary'),
        }]}
      />
    </>
  );
}

export default LegalCustomerBookingInfo;
